"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
var _locale = require("../locale");
var _constants = require("../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var DemoCard = function DemoCard(_ref) {
  var item = _ref.demo;
  var _theme$useToken = _antd.theme.useToken(),
    token = _theme$useToken.token;
  var locale = (0, _locale.useLocale)();
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedTokens = _useState2[0],
    setSelectedTokens = _useState2[1];
  var toggle = function toggle(targetToken) {
    return function () {
      setSelectedTokens(function (prev) {
        return prev.includes(targetToken) ? prev.filter(function (t) {
          return t !== targetToken;
        }) : [].concat((0, _toConsumableArray2.default)(prev), [targetToken]);
      });
    };
  };
  var tokenOverride = (0, _react.useMemo)(function () {
    return selectedTokens.reduce(function (result, t) {
      result[t] = _constants.HIGHLIGHT_COLOR;
      return result;
    }, {});
  }, [selectedTokens]);
  var shownTokens = (0, _react.useMemo)(function () {
    var _item$tokens$filter, _item$tokens;
    return (_item$tokens$filter = (_item$tokens = item.tokens) === null || _item$tokens === void 0 ? void 0 : _item$tokens.filter(function (t) {
      return t.toLowerCase().includes('color');
    })) !== null && _item$tokens$filter !== void 0 ? _item$tokens$filter : [];
  }, [item.tokens]);
  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    bodyStyle: {
      padding: 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 20
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: {
      token: tokenOverride
    }
  }, item.demo)), shownTokens.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      background: token.colorFillQuaternary,
      padding: '12px 20px 20px',
      borderRadius: "0 0 ".concat(token.borderRadiusLG, "px ").concat(token.borderRadiusLG, "px"),
      boxShadow: 'inset 0 2px 4px 0 rgba(25,15,15,0.07)'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: token.colorTextDescription,
      marginBottom: 12
    }
  }, locale.demo.relatedTokensDescription), shownTokens.map(function (t) {
    return /*#__PURE__*/_react.default.createElement(_antd.Tag, {
      bordered: false,
      key: t,
      onClick: toggle(t),
      color: selectedTokens.includes(t) ? 'blue' : undefined,
      style: {
        cursor: 'pointer',
        userSelect: 'none'
      }
    }, t);
  })));
};
var _default = exports.default = DemoCard;